import React from 'react';
import { Link } from 'react-router-dom';

const WhyChoose = () => {
  const reasons = [
    {
      image: '/images/quality-you-can-rely-on.png',
      title: 'Quality You Can Rely On',
      description: 'Every Trolift product is built with precision and tested for durability to ensure long-lasting performance.'
    },
    {
      image: '/images/right-price-real-value.png',
      title: 'Right Price, Real Value',
      description: 'Our equipment is designed with safety as the top priority, featuring anti-slip surfaces and robust construction.'
    },
    {
      image: '/images/experience-that-delivers.png',
      title: 'Experience That Delivers',
      description: 'Backed by years of industry expertise, our team ensures seamless service and trusted support every step of the way'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-catalina-blue text-center mb-4">Why Choose Trolift?</h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          We deliver excellence in every aspect of our lifting solutions
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg text-center hover:shadow-lg transition duration-300">
              <div className="flex justify-center mb-4 rounded-lg">
                <img src={reason.image} alt={reason.title} className="w-48 h-48 object-contain rounded-lg" />
              </div>
              <h3 className="text-xl font-bold text-catalina-blue mb-3">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
        <div className="text-center">
          <Link 
            to="/contact" 
            className="inline-block bg-catalina-blue text-white px-8 py-3 rounded-md font-semibold hover:bg-san-marino transition duration-300"
          >
            Get Started Today
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;